import { Link } from 'react-router-dom';
import { categories } from '@/mocks/products';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
              精品国产
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              汇聚中国匠心制造的高品质国货精品。严选真正值得信赖的国产好物，助您告别踩坑，轻松找到性价比之王。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/" className="hover:text-primary-400 transition-colors">分类导航</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/article/2024-guohuo-shouji-pingce" className="hover:text-primary-400 transition-colors">精选文章</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/2024-guohuo-shouji-pingce" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  国产旗舰手机横评
                </Link>
              </li>
              <li>
                <Link to="/article/guochao-pinpai-anzou-shijie" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  国货品牌走向世界
                </Link>
              </li>
              <li>
                <Link to="/article/guohuo-hufupin-tuiijian" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  国货护肤品推荐
                </Link>
              </li>
              <li>
                <Link to="/article/guohuo-yundongxie-pingce" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  国产跑鞋大横评
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-primary-400 transition-colors">关于我们</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  用户口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-booklet-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-500">
          <p>&copy; 2024 精品国产 All Rights Reserved.</p>
          <p>
            <a href="/" className="hover:text-background-300 transition-colors">首页</a>
            <span className="mx-2">·</span>
            <a href="/about" className="hover:text-background-300 transition-colors">关于我们</a>
          </p>
        </div>
      </div>
    </footer>
  );
}